import { HasKind } from '@/utilities/HasKind';

import { Crumbs } from '../../bakery/Crumbs';
import { crumble as crumbleDatabase, Database } from '../../Database';

export const kind = 'InitializeComplete';

export interface InitializeComplete extends HasKind<typeof kind> {
  database: Database;
}

export function crumble(action: InitializeComplete): Crumbs {
  return {
    database: crumbleDatabase(action.database),
  };
}
